import { gql } from 'apollo-angular'

export const CREATE_NOTIFICATION_OPT_OUT = gql`
  mutation CreateNotificationOptOut($magazineId: Int!) {
    createMagazineNotificationOptOut(data: { magazine: $magazineId }) {
      id
      magazine {
        id
      }
    }
  }
`
